/*
 * Copyright (c) 2023 Potentially Ltd
 *
 * Please see distribution for license
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'truncate' })
export class TruncatePipe implements PipeTransform {
  transform(value: string, maxLength: number): string {
    if (!value) {
      return value;
    }
    if (value.length <= maxLength) {
      return value;
    } else {
      return value.substring(0, maxLength) + '...';
    }
  }
}
